export const incomeProofFieldName = "proof_of_income_date"

export const admissionDateMaximumYearsOld = 60

export const incomeProofMaximumMonthsOld = 3

export const needIncomeProofFieldName = "need_proof_of_income"

export const insertIncomeProofBefore = "work_document_type"
export const incomeProofAlertMessage = "Obrigatório o envio de um comprovante de renda com data nos últimos 3 meses."